import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import jsonp from "../../assets/js/http"
import slipBlock from '../..//theme/components/slipBlock/slipBlock.vue'
import _com from '../../assets/js/common'

@Component({
  components: {
    slipBlock
  }
})
export default class login extends Vue {
  codeText: string = '发送验证码'
  tab: number = 1
  isSending: boolean = false
  phone: string = ''
  vcode: string = ''
  showBlock: boolean = false
  count: number = 60
  token: any = ''
  target: any = ''
  isLoading: boolean = false
  userName: string = ''
  password: string = ''
  pwOpen: boolean = false
  isAgree: boolean = false
  mounted() {
    this.token = this.$route.query.token || ''
    this.target = this.$route.query.target ? decodeURIComponent(this.$route.query.target as string) : ''
  }
  // 切换登录方式
  changeTab (tab: number) {
    this.tab = tab
  }

  // 发送验证码
  sendCode () {
    if (this.isSending) return false
    this.showBlock = true
  }

  sendSmsCode (data: any) {
    this.isSending = true
    jsonp(`https://m${process.env.VUE_APP_URI_DOMAIN}/mthirdparty/psbc/sendLiveSms`, {
      jsoncallback: 'jsoncallback1',
      mobile: _com.encrypted(this.phone),
      validateKey: data
    }).then((res: any) => {
      let tid = setInterval(() => {
        this.count--
        if (this.count <= 0) {
          this.codeText = '重新发送'
          clearInterval(tid)
          this.isSending = false
          this.count = 60
          return false
        }
        this.codeText = this.count + 's后重新发送'
      }, 1000)
    }, (err: any) => {
      this.isSending = false
      this.$toast(err.msg)
    })
  }

  // 滑块验证数据
  valideteEvent (res: any) {
    this.closeBlock()
    if (res) {
      this.sendSmsCode(res)
    }
  }

  closeBlock () {
    this.showBlock = false
  }

  // 立即关联
  confirmContact () {
    if (this.isLoading) return false
    if (this.tab == 1 && !this.phone) {
      this.$toast('请输入手机号码')
      return false
    }
    if (this.tab == 1 && !this.vcode) {
      this.$toast('请输入验证码')
      return false
    }
    if (this.tab == 2 && !this.userName) {
      this.$toast('请输入邮乐账号')
      return false
    }
    if (this.tab == 2 && !this.password) {
      this.$toast('请输入密码')
      return false
    }
    if (!this.isAgree) {
      this.$toast('请勾选协议')
      return false
    }
    this.isLoading = true
    if (this.tab == 1) {
      this.contactPhone()
    } else {
      this.contactUser()
    }
  }
  
  // 手机号绑定
  contactPhone () {
    jsonp(`https://m${process.env.VUE_APP_URI_DOMAIN}/mthirdparty/psbc/psbcLiveRegisterBind`, {
      mobile: _com.encrypted(this.phone),
      validateCode: _com.encrypted(this.vcode),
      token: this.token,
      jsoncallback: 'jsoncontact'
    }).then((res: any) => {
      console.log('手机号success:', res)
      this.isLoading = false
      if (this.target) {
        location.href = this.target
      }
    }, (err: any) => {
      console.log('手机error:', err)
      this.isLoading = false
      this.$toast(err.msg || err.returnMessage || err.message)
    })
  }

  // 账号绑定
  contactUser () {
    jsonp(`https://m${process.env.VUE_APP_URI_DOMAIN}/mthirdparty/psbc/psbcLiveLoginBind`, {
      userName: _com.encrypted(this.userName),
      pwd: _com.encrypted(this.password),
      token: this.token,
      jsoncallback: 'jsoncontact'
    }).then((res: any) => {
      console.log('账号success:', res)
      this.isLoading = false
      if (this.target) {
        location.href = this.target
      }
    }, (err: any) => {
      console.log('账号error:', err)
      this.isLoading = false
      this.$toast(err.msg || err.returnMessage || err.message)
    })
  }

  openPwd () {
    this.pwOpen = !this.pwOpen
  }

  selectAgree () {
    this.isAgree = !this.isAgree
  }
}